import React from "react";
import './style.scss';
import LogoSloganImage from "../../../resources/images/ShipitLogoWithSlogan.png";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import DeleteOrdersConfirmationDialog from "./DeleteOrdersConfirmationDialog/DeleteOrdersConfirmationDialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import Direction from "../../Utils/Direction/Direction";
import moment from "moment";
import Checkbox from "@material-ui/core/Checkbox";


export default class DeleteOrders extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bid: '',
            timeGtText: moment().format('YYYY-MM-DDTHH:mm'),
            timeLtText: moment().format('YYYY-MM-DDTHH:mm'),
            isTimeGtEnabled: false,
            isTimeLtEnabled: false,
            isConfirmationDialogOpen: false
        };
    }

    handleBidChange(event) {
        this.setState({
            bid: event.target.value
        });
    }

    handleTimeGtChange(event) {
        this.setState({
            timeGtText: event.target.value
        });
    }

    handleTimeLtChange(event) {
        this.setState({
            timeLtText: event.target.value
        });
    }

    handleCheckboxTimeGtChange(event, value) {
        this.setState({
            isTimeGtEnabled: value
        });
    }

    handleCheckboxTimeLtChange(event, value) {
        this.setState({
            isTimeLtEnabled: value
        });
    }

    handleDeleteButton() {
        this.setState({
            isConfirmationDialogOpen: true
        });
    }

    closeConfirmationDialog() {
        this.setState({
            isConfirmationDialogOpen: false
        });
    }

    async handleDeleteConfirmed() {
        if (this.clearSuccessTimeout)
            clearTimeout(this.clearSuccessTimeout);

        this.closeConfirmationDialog();

        this.setState({
            isDeleteLoading: true,
            isDeleteSuccess: undefined
        });

        const requestBody = {
            bid: this.state.bid
        };

        if (this.state.isTimeGtEnabled)
            requestBody.timeGt = moment(this.state.timeGtText, 'YYYY-MM-DDTHH:mm');

        if (this.state.isTimeLtEnabled)
            requestBody.timeLt = moment(this.state.timeLtText, 'YYYY-MM-DDTHH:mm');

        const {data: result} = await axios.post('/api/v2a/deleteOrders', requestBody);

        this.setState({
            isDeleteLoading: false,
            isDeleteSuccess: result.success
        });

        this.clearSuccessTimeout = setTimeout((() => {
            this.setState({
                isDeleteSuccess: undefined
            });

            this.clearSuccessTimeout = undefined;
        }).bind(this), 2000);
    }

    render() {
        return (
            <Direction direction="rtl">
                <div className="page">
                    <div className="logo">
                        <img src={LogoSloganImage}/>
                    </div>

                    <div className="content">
                        <div className="page-title-text">
                            מחיקת הזמנות בסטטוס ״התקבל״
                        </div>
                        <div className="delete-orders-content">
                            <TextField label={"מזהה העסק"}
                                       placeholder={"הקלד מזהה עסק"}
                                       value={this.state.bid}
                                       onChange={this.handleBidChange.bind(this)}
                                       className="bid-input"/>
                            <div className="checkbox-time-container">
                                <Checkbox
                                    checked={this.state.isTimeGtEnabled}
                                    onChange={this.handleCheckboxTimeGtChange.bind(this)}
                                />
                                <TextField
                                    id="datetime-local"
                                    className="time-input"
                                    label="הזמנות שנכנסו לאחר הזמן"
                                    type="datetime-local"
                                    value={this.state.timeGtText}
                                    disabled={!this.state.isTimeGtEnabled}
                                    onChange={this.handleTimeGtChange.bind(this)}
                                />
                            </div>
                            <div className="checkbox-time-container">
                                <Checkbox
                                    checked={this.state.isTimeLtEnabled}
                                    onChange={this.handleCheckboxTimeLtChange.bind(this)}
                                />
                                <TextField
                                    id="datetime-local"
                                    className="time-input"
                                    label="הזמנות שנכנסו לפני הזמן"
                                    type="datetime-local"
                                    value={this.state.timeLtText}
                                    disabled={!this.state.isTimeLtEnabled}
                                    onChange={this.handleTimeLtChange.bind(this)}
                                />
                            </div>
                            <div className="delete-button-container">
                                <Button
                                    disabled={this.state.isDeleteLoading}
                                    className={`delete-button ${(this.state.isDeleteSuccess === true ? 'delete-button-success' : this.state.isDeleteSuccess === false ? 'delete-button-failure' : '')}`}
                                    variant="contained" color="primary"
                                    onClick={this.handleDeleteButton.bind(this)}>
                                    מחק
                                </Button>
                                {this.state.isDeleteLoading &&
                                <CircularProgress size={24} className="delete-button-loader"/>}
                            </div>
                        </div>
                    </div>

                    <DeleteOrdersConfirmationDialog open={this.state.isConfirmationDialogOpen}
                                                    bid={this.state.bid}
                                                    onCancel={this.closeConfirmationDialog.bind(this)}
                                                    onDelete={this.handleDeleteConfirmed.bind(this)}/>
                </div>
            </Direction>
        );
    }
}